import english from "Infrastructure/Translation/en/index.ts";
import { Language, type Languages } from "Infrastructure/Translation/types.ts";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
	en: { translation: english },
	gb: { translation: english },
};

export const languages: Languages = [
	{
		id: Language.en,
		icon: "EN",
		name: "English",
	},
	{
		id: Language.gb,
		icon: "GB",
		name: "English",
	},
];

i18n.use(initReactI18next).init({
	resources,
	lng: Language.gb,
	fallbackLng: Language.gb,
	interpolation: {
		escapeValue: false,
	},
});

export default i18n;
